import React from "react";
import { Modal, Button } from "react-bootstrap";
import RenderCustomerItem from "./RenderCustomerItem";

export default function({ show, close, data, remove }) {
  return (
    <Modal show={ show } onHide={ close }>

      <Modal.Header closeButton>
        <Modal.Title>Field Preview</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <RenderCustomerItem data={ data } />
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={ close }>Cancel</Button>
        <Button onClick={ remove } bsStyle="warning">Delete</Button>
      </Modal.Footer>

    </Modal>
  )
}



// WEBPACK FOOTER //
// ./src/components/Settings/Customers/PreviewCustomerInfo.js